import { get, post } from "../../../shared/data";

export const searchUpc = (upc) => {
    const url = `/tasking/contexts?upc=${upc}`;

    return get(url);
};

export const undoToIntake = (key) => {
    return post(`/receiving/final/${key}/cancel-finalqa`);
};

export const sendToIntake = (key, force) => {
    const forceParam = force ? "?confirm=true" : "";

    return post(`/receiving/final/${key}/re-finalqa${forceParam}`, "", { passthrough: true });
};

export const sendToExternal = (taskKeys, destinationKey, updatePostDate, sendToGdsn) => {
    const payload = {
        items: taskKeys.map((taskKey) => {
            return { taskContextKey: taskKey, destinationKeys: destinationKey, updatePostDate, sendToGdsn };
        }),
    };

    return post("/admin/resubmit", payload);
};
